(() => {
  const root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  const drawer = document.querySelector('[data-mobile-drawer]');
  const openButton = document.querySelector('[data-menu-open]');
  const closeButton = document.querySelector('[data-menu-close]');

  const closeDrawer = () => {
    if (!drawer || !openButton) return;
    drawer.hidden = true;
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  };

  const openDrawer = () => {
    if (!drawer || !openButton) return;
    drawer.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
    closeButton?.focus();
  };

  openButton?.addEventListener('click', openDrawer);
  closeButton?.addEventListener('click', closeDrawer);
  drawer?.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll('[data-nav-root] details').forEach((detail) => {
    detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      detail.closest('[data-nav-root]')?.querySelectorAll('details[open]').forEach((other) => {
        if (other !== detail) other.removeAttribute('open');
      });
    });
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.querySelector('[data-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    control.querySelector('[data-plus]')?.addEventListener('click', () => {
      input.value = Math.min(Number(input.max || 999), Number(input.value || 1) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const productRoot = select.closest('[data-product-root]');
      const price = productRoot?.querySelector('[data-product-price]');
      const button = productRoot?.querySelector('[data-add-button]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableText : button.dataset.soldText;
      }
      if (option.dataset.image) {
        const main = productRoot?.querySelector('[data-gallery-main]');
        if (main) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = option.dataset.image;
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    });
  });
})();
